import i18n from 'i18next';

import { AssetUploadType } from '@/enums';
import { PhotoFilmIcon, PlusIcons } from '@/resources';
import { SidebarAssets } from '@/resources/icons/sidebar';

import { bytesToMegabytes } from './BlobAssetHelper';

export const getBackgroundUploadOptions = () => [
  {
    value: AssetUploadType.PUBLIC_ASSET,
    icon: <PhotoFilmIcon className='mr-1 w-6 text-primary-blue' />,
    label: i18n.t('publicAssets', { ns: 'common' })
  },
  {
    value: AssetUploadType.UPLOADED_CONTENT,
    icon: <PhotoFilmIcon className='mr-1 w-6 text-primary-blue' />,
    label: i18n.t('uploadedContent', { ns: 'common' })
  },
  {
    value: AssetUploadType.UPLOAD_NEW,
    icon: <PlusIcons fill='var(--color-primary-blue)' className='mr-1 w-6' />,
    label: i18n.t('uploadNew', { ns: 'common' })
  }
];

export const getContentUploadOptions = () => [
  {
    value: AssetUploadType.UPLOAD_NEW,
    icon: <PhotoFilmIcon className='ml-2 w-5 text-primary-blue' />,
    label: i18n.t('uploadMedia', { ns: 'common' }),
    description: i18n.t('maxFileSize', {
      size: bytesToMegabytes(window.MAX_ASSET_UPLOAD_SIZE),
      ns: 'common'
    })
  },
  {
    value: AssetUploadType.ORGANIZATION_ASSET,
    icon: <SidebarAssets className='ml-2 w-6 text-3xl text-primary-blue' />,
    label: i18n.t('organizationAssets', { ns: 'common' })
  }
];

